import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const CreditEditConfirmModel = ({
  show,
  onClose,
  creditData,
  onConfirm,
  update_operation,
  amount,
  modelMode,
}) => {
  const { user_name, email, symbol, available_balance, role, id, alert_balance } = creditData || {};

  var credit_balance, credit_amount, new_balance;

  if (update_operation === 'topup') new_balance = available_balance + parseFloat(amount);
  if (update_operation === 'deduct') new_balance = available_balance - parseFloat(amount);
  if (update_operation === 'alert_balance') new_balance = amount;

  if (white_label_perkeso) {
    credit_balance = available_balance;
    credit_amount = amount;
  }

  if (!white_label_perkeso) {
    credit_balance = symbol + ' ' + available_balance;
    credit_amount = symbol + ' ' + amount;
    new_balance = symbol + ' ' + new_balance;
  }

  return (
    <Modal show={show} onHide={onClose} animation={true} centered>
      <Modal.Body>
        <CloseIcon handleModalClose={onClose} />
        <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
          {modelMode === 'balance_alert'
            ? 'Edit Credit Balance Alert Confirmation'
            : 'Edit Credit Balance Confirmation'}
        </Modal.Title>
        <p>
          <strong>User ID:</strong> {id}
        </p>
        <p>
          <strong>Name:</strong> {user_name}
        </p>
        <p>
          <strong>Email:</strong> {email}
        </p>

        {white_label_perkeso && (
          <p>
            <strong>Role:</strong> {role}
          </p>
        )}

        {modelMode === 'balance' && (
          <>
            <p>
              <strong>Credit Balance: {credit_balance}</strong>
            </p>
            <hr />
            <p>
              <strong>
                {update_operation === 'topup' ? 'Add Credit' : 'Deduct Credit'}: {credit_amount}
              </strong>
            </p>
          </>
        )}

        <p
          style={{
            backgroundColor: '#d4edda',
            color: 'black',
            padding: '10px',
            borderRadius: '5px',
            display: 'block',
            marginBottom: '10px',
            fontSize: '14px',
          }}
        >
          {modelMode === 'balance' && (
            <>
              New Credit Balance<strong> {new_balance}</strong>
            </>
          )}
          {modelMode === 'balance_alert' && (
            <>
              Update Credit Balance Alert from
              <strong> {alert_balance}</strong> to
              <strong> {new_balance}</strong>
            </>
          )}
        </p>
        <div className="d-flex justify-content-left" style={{ marginTop: 24, gap: 16 }}>
          <Button variant="primary" onClick={onConfirm} style={{ minWidth: '160px' }}>
            Yes
          </Button>
          <Button variant="ghost" onClick={onClose} style={{ minWidth: '160px' }}>
            No
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreditEditConfirmModel;
